import { FormikHelpers, useFormik } from 'formik';
import { PartnerEdit, Partner } from '../partner';
import {
  Grid,
  TextField,
  Box,
  FormHelperText,
  Paper,
  Button,
} from '@mui/material';
import { getMediaUrl } from '../../../core/utils/image';

type PartnerProps = {
  onSubmit: (
    value: PartnerEdit,
    helpers: FormikHelpers<PartnerEdit>
  ) => Promise<void>;
  submitting: boolean;
  partner: Partner;
};

const EditPartnerForm = ({ onSubmit, submitting, partner }: PartnerProps) => {
  const handleSubmit = async (
    value: PartnerEdit,
    helpers: FormikHelpers<PartnerEdit>
  ) => {
    await onSubmit(value, helpers);
  };

  const initialValues: PartnerEdit = {
    name: partner.name,
    image: null,
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  // console.log('Edit Form', initialValues);

  return (
    <>
      <Box sx={{ flexGrow: 1, maxWidth: 400 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={1}>
            <Paper sx={{ p: 2, pb: 3 }}>
              <Grid
                container
                justifyContent="space-between"
                spacing={1}
                sx={{ mt: 2 }}
              >
                <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                  <TextField
                    fullWidth
                    name="name"
                    size="small"
                    type="text"
                    variant="outlined"
                    label="Name"
                    placeholder=""
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.name)}
                    helperText={formik.errors.name}
                  />
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent="space-between"
                spacing={1}
                sx={{ mt: 2 }}
              >
                <Grid item alignSelf="flex-start" sx={{ flexGrow: 1 }}>
                  <Grid item xs={12}>
                    Image
                  </Grid>

                  <Grid item sx={{ mr: 3 }}>
                    <img
                      src={getMediaUrl(
                        partner.media.length ? partner.media[0] : null
                      )}
                      width="256px"
                      alt="cover"
                    />
                  </Grid>
                  <Box>
                    <input
                      type="file"
                      onChange={({ target: { files } }) => {
                        formik.setFieldValue(
                          'image',
                          files && files.length ? files[0] : null
                        );
                      }}
                      name="image"
                    />
                  </Box>
                  {formik.touched.image && formik.errors.image && (
                    <FormHelperText error>{formik.errors.image}</FormHelperText>
                  )}
                </Grid>
              </Grid>

              <Grid container sx={{ mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  disabled={submitting}
                  size="small"
                  fullWidth
                >
                  {submitting ? 'Saving' : 'Save'}
                </Button>
              </Grid>
            </Paper>
          </Grid>
        </form>
      </Box>
    </>
  );
};

export default EditPartnerForm;
